/**
 * Matches zExponentialDecayAnalysis.has_non_english_characters:
 * any code point outside ASCII ⇒ non-English for NEC filtering.
 */
export function hasNonEnglishCharacters(text) {
  if (text == null) return false
  const s = String(text)
  if (!s) return false
  for (let i = 0; i < s.length; i += 1) {
    if (s.charCodeAt(i) > 127) return true
  }
  return false
}

/**
 * Columns checked for NEC (track discovery uses title + display artist).
 * Override via `hideNonEnglishColumns` prop when needed.
 */
export const DEFAULT_NEC_COLUMNS = [
  'Track Title',
  'Display Artist',
  'Title',
  'Name',
  'Artist',
  'Primary Artist',
]

export function rowHasNonEnglish(row, columns = DEFAULT_NEC_COLUMNS) {
  if (!row || !columns?.length) return false
  return columns.some((col) => hasNonEnglishCharacters(row[col]))
}
